import { render, staticRenderFns } from "./Admins.vue?vue&type=template&id=1629cf06&scoped=true"
import script from "./Admins.vue?vue&type=script&lang=js"
export * from "./Admins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1629cf06",
  null
  
)

export default component.exports